<template>
  <div>
    <vs-table :data="projects">

      <template slot="thead">
        <vs-th :class="{'float-right': title === $t('clients.table.actions')}" :key="i" class="text-base"
               v-for="(title, i) in header">{{ title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.code">
            {{ tr.code }}
          </vs-td>
          <vs-td :data="tr.name">
            {{ tr.name }}
          </vs-td>
          <vs-td :data="tr.client.name">
            {{ tr.client.name }}
          </vs-td>
          <vs-td :data="tr.estimation" class="whitespace-pre w-20 text-right">
            {{ tr.estimation }}
          </vs-td>
          <vs-td :data="tr.start_date" class="whitespace-pre">
            {{ tr.start_date | date('MMM Do YYYY') }}
          </vs-td>
          <vs-td :data="tr.end_date" class="whitespace-pre">
            {{ tr.end_date | date('MMM Do YYYY') }}
          </vs-td>
          <vs-td class="text-right">
            <div class="flex justify-end">
              <vx-tooltip :text="$t('buttons.edit')" position="top">
                <base-button @click="$emit('edit', tr.id)" class="self-end px-3 mx-px" icon="pen"/>
              </vx-tooltip>
              <vx-tooltip :text="$t('buttons.delete')" position="top">
                <base-button :loading="deleteLoaders[tr.id]" @click="$emit('delete', tr.id)" class="self-end px-3 mx-px" color="danger"
                             icon="trash"/>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>

  export default {
    name: 'ProjectsTable',
    components: {},
    props: {
      header: {
        type: Array,
        required: true
      },
      projects: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      deleteLoaders: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      startLoading () {
        this.$vs.loading({
          container: this.$refs.projectsTable,
        })
      },
      stopLoading () {
        this.$vs.loading.close(this.$refs.projectsTable)
      },
    },
    watch: {
      loading (newValue) {
        if (newValue) this.startLoading()
        else this.stopLoading()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
